/** Small data hooks over the API (server-side RLS does the scoping). */
import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { api } from './api.js';
import { dataVersionState } from './state.js';

export interface Loaded<T> {
  data: T | null;
  error: string | null;
  loading: boolean;
}

export function useApi<T>(path: string | null): Loaded<T> {
  const version = useRecoilValue(dataVersionState);
  const [state, setState] = useState<Loaded<T>>({ data: null, error: null, loading: !!path });
  useEffect(() => {
    if (!path) {
      setState({ data: null, error: null, loading: false });
      return;
    }
    let alive = true;
    setState((s) => ({ ...s, loading: true }));
    api
      .get<T>(path)
      .then((data) => alive && setState({ data, error: null, loading: false }))
      .catch((e) => alive && setState({ data: null, error: String(e.message ?? e), loading: false }));
    return () => {
      alive = false;
    };
  }, [path, version]);
  return state;
}
